import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useFollowingFeedStore = defineSmartFeedPiniaStore("following-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    orgId: 0,
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
    },
  }),
  getters: {
    defaultFilterValues() {
      return {
        orgId: {
          "key": "org_id",
          "payload": this.orgId,
        },
      };
    },
    feedUrl() {
      return `/following/org/${this.orgId}`;
    },
  },
});
